import axios from 'axios';
import React, { useState } from 'react';
import styled from 'styled-components';
import { media } from '../../utils/styles';
import { Button } from '../common';
import { SuccessScreen } from './SuccessScreen';

const INITIAL_FORM_DATA = {
  name: '',
  email: '',
  phone: '',
  message: '',
};

export const ContactForm = () => {
  const [state, setState] = useState({
    isLoading: false,
    showSuccessScreen: false,
    ...INITIAL_FORM_DATA,
  });

  const onChange = e => {
    setState(prevState => ({ ...prevState, [e.target.name]: e.target.value }));
  };

  const onSubmit = async e => {
    e.preventDefault();
    try {
      setState(prevState => ({ ...prevState, isLoading: true }));
      await axios.post('/.netlify/functions/contact-form', state);
      setState(prevState => ({
        ...prevState,
        ...INITIAL_FORM_DATA,
        isLoading: false,
        showSuccessScreen: true,
      }));
    } catch (error) {
      window.Sentry.captureException(error);
      alert('An error occured!');
      setState(prevState => ({ ...prevState, isLoading: false }));
    }
  };

  return (
    <Form onSubmit={onSubmit}>
      <Inner>
        <Heading>Send us a message</Heading>
        <Group>
          <Input
            name="name"
            required
            type="text"
            placeholder="Name *"
            value={state.name}
            onChange={onChange}
          />
        </Group>
        <Group>
          <Input
            name="email"
            required
            type="email"
            placeholder="Email *"
            value={state.email}
            onChange={onChange}
          />
        </Group>
        <Group>
          <Input
            name="phone"
            type="text"
            placeholder="Phone number"
            value={state.phone}
            onChange={onChange}
          />
        </Group>
        <Group>
          <Textarea
            as="textarea"
            placeholder="Message *"
            required
            name="message"
            value={state.message}
            onChange={onChange}
          />
        </Group>
        <Submit type="submit" disabled={state.isLoading} isLoading={state.isLoading}>
          Send
        </Submit>
      </Inner>
      {state.showSuccessScreen && (
        <SuccessScreen
          onClose={() => setState(prevState => ({ ...prevState, showSuccessScreen: false }))}
        />
      )}
    </Form>
  );
};

const Form = styled.form`
  background: #ffffff;
  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.04);
  border-radius: 2px;
  width: 510px;
  max-width: 100%;
  padding: 66px 0;
  position: relative;
  ${media.tablet} {
    width: 400px;
  }
  ${media.phone} {
    padding: 45px 0;
  }
`;

const Inner = styled.div`
  width: 330px;
  max-width: 100%;
  margin: 0 auto;
  ${media.phone} {
    width: 100%;
    padding: 0 30px;
  }
`;

const Input = styled.input`
  background: #ffffff;
  border: 1px solid rgba(0, 0, 0, 0.1);
  box-sizing: border-box;
  border-radius: 30px;
  width: 100%;
  height: 50px;
  display: flex;
  padding: 0 28px;
  align-items: center;
  font-size: 16px;
  line-height: 1;
  color: rgba(27, 27, 27, 0.8);
  transition: 0.2s ease-out border-color;
  outline: none !important;
  &::placeholder {
    color: rgba(27, 27, 27, 0.8);
  }
  &:focus {
    border-color: #000000;
  }
`;

const Textarea = styled(Input)`
  height: 108px;
  border-radius: 30px;
  font-family: inherit;
  padding: 16px 28px;
`;

const Group = styled.div`
  margin: 0 0 10px;
`;

const Submit = styled(Button)`
  width: 100%;
  margin-top: 30px;
`;

const Heading = styled.h4`
  margin: 0 0 47px;
  font-weight: 600;
  font-size: 22px;
  line-height: 26px;
  text-align: center;
`;
